import React from 'react';
import _ from 'lodash';

import {
  useReturnItemModalQuery,
  useTriageTier1ReturnAuthorizationMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  triageWorkflowId: string;
  formState: types.IFormState;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useReturnItemModalQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        triageWorkflowId: _.find(tuple.data?.tier1ReturnAuthorization?.group.store.triageWorkflows, wf => wf.type.name === 'return')?.id ?? '',
        formState: {
          serialNumber: tuple.data?.tier1ReturnAuthorization?.itemReceipt?.serialNumber ?? '',
          technicianComment: ''
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useTriageTier1ReturnAuthorization(returnAuthorizationId: string, triageWorkflowId: string) {
  const [fnMutate, tuple] = useTriageTier1ReturnAuthorizationMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            returnAuthorizationId,
            triageWorkflowId,
            technicianComment: formState.technicianComment
          }
        }
      });
    },
    [
      fnMutate,
      returnAuthorizationId,
      triageWorkflowId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
